(function () {
  document.querySelectorAll('[data-bslider]').forEach(function (root) {
    var track = root.querySelector('[data-bs-track]');
    var prev = root.querySelector('[data-bs-prev]');
    var next = root.querySelector('[data-bs-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return (card.offsetWidth + gap) * Math.max(1, Math.floor(track.clientWidth / (card.offsetWidth + gap)));
    }
    // Pfeile nur zeigen, wenn in der Richtung noch Marken folgen
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max - 2;
    }

    // Pfeile exakt auf die vertikale Mitte der Kacheln setzen
    function center() {
      var tile = track.querySelector('.brand__tile');
      if (!tile) return;
      var y = tile.getBoundingClientRect().top - root.getBoundingClientRect().top + tile.offsetHeight / 2;
      prev.style.top = next.style.top = y + 'px';
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { update(); center(); });
    window.addEventListener('load', center);
    update();
    center();
  });
})();
